import React, { useState } from 'react'
import { Button, Card, Col, Container, Form, Jumbotron, Row, Alert } from 'react-bootstrap'
import { useHistory } from 'react-router'
import { GenerateRandomNumber, UpdateDocument } from '../../../firebase/firebase'
export const SurveyForm = () => {
    const history = useHistory()
    const [error, setError] = useState('')
    const [surveyForm, setSurveyForm] = useState({
        age: '',
        sex: '',
        height: '',
        weight: '',
        race: '',
        hadBariatricSurgery: '',
        educationLevel: '',
        preferToLearn: ''
    })
    const [done, setDone] = useState(false)


    const onChange = (e) => {
        setSurveyForm({ ...surveyForm, [e.target.name]: e.target.value })
        console.log(surveyForm)
    }

    const handleRadioButton = (attribute, value) => {
        setSurveyForm({ ...surveyForm, [attribute]: value })
        console.log(surveyForm)
    }

    const handleSubmit = async (e, user, changedImage) => {
        e.preventDefault()

        if (surveyForm.hadBariatricSurgery === '' ||
            surveyForm.age === '' ||
            surveyForm.height === '' ||
            surveyForm.weight === '' ||
            surveyForm.race === '' ||
            surveyForm.sex === '' ||
            surveyForm.hadBariatricSurgery === '' ||
            surveyForm.educationLevel === '' ||
            surveyForm.preferToLearn === '') {
            return setError("Please fill out all questions.")
        }

        try {

            let surveyToUpload = { ...surveyForm }
            Object.keys(surveyToUpload).map((key) => {
                if (surveyToUpload[key] == 'on') {
                    surveyToUpload[key] = true
                }

            })

            surveyToUpload.id = GenerateRandomNumber()

            await UpdateDocument('surveys', surveyToUpload, false)

            setDone(true)

        }

        catch (e) {
            setError(error)

        }

    }

    const questions = [
        <AgeInput onChange={onChange} surveyForm={surveyForm} />,
        <HeightInput onChange={onChange} surveyForm={surveyForm} />,
        <WeightInput onChange={onChange} surveyForm={surveyForm} />,
        <SexInput onChange={handleRadioButton} surveyForm={surveyForm} name='sex' />,
        <RaceInput onChange={handleRadioButton} surveyForm={surveyForm} name='race' />,
        <MedicalConditionsInfluenceDiet onChange={onChange} surveyForm={surveyForm} />,
        <FoodRestrictionsValues onChange={onChange} surveyForm={surveyForm} />,
        <DietsTriedInPast onChange={onChange} surveyForm={surveyForm} />,
        <OnDiet onChange={onChange} surveyForm={surveyForm} />,
        <HaveHadBariatricSurgery onChange={handleRadioButton} surveyForm={surveyForm} name='hadBariatricSurgery' />,
        <EducationLevel onChange={handleRadioButton} surveyForm={surveyForm} name='educationLevel' />,
        <InterestedLearningAbout onChange={onChange} surveyForm={surveyForm} />,
        <HowPreferToLearn onChange={handleRadioButton} surveyForm={surveyForm} name='preferToLearn' />
    ]

    if (done) {
        return (

            <Container fluid>
                <Row className="justify-content-center">
                    <Col sm={12}>
                        <Jumbotron className='text-center'>
                            <h1>Thank You! Your response has been recorded</h1>
                        </Jumbotron>
                    </Col>
                </Row>
            </Container>


        )
    }
    else {
        return (
            <Row className='d-flex justify-content-center align-items-center'>
                <Col lg={10} >
                    <Card>
                        <Card.Body>
                            <Card.Header>
                                Survey
                            </Card.Header>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleSubmit}>

                                {questions.map((question, index) => (
                                    <Row className='py-2' key={index}>
                                        {question}
                                    </Row>
                                ))}


                                <Row className='justify-content-center py-3'>
                                    <Col xs={8} xl={6} className='text-center'>
                                        <Button type='submit'>
                                            Submit
                                        </Button>
                                    </Col>
                                </Row>

                            </Form>
                        </Card.Body>
                    </Card>

                </Col>
            </Row >
        )
    }
}




const AgeInput = (props) => {
    return (
        <>
            <Form.Label>Age</Form.Label>
            <Form.Control

                onChange={props.onChange}
                type="number"
                required
                placeholder='Age'
                value={props.surveyForm.age}
                name='age'
            />
        </>
    )
}

const HeightInput = (props) => {
    return (
        <>
            <Form.Label>Height (inches)</Form.Label>
            <Form.Control

                onChange={props.onChange}
                type="number"
                required
                placeholder='Height in Inches'
                value={props.surveyForm.height}
                name='height'
            />

        </>
    )
}

const WeightInput = (props) => {
    return (
        <>
            <Form.Label>Weight</Form.Label>
            <Form.Control

                onChange={props.onChange}
                type="number"
                required
                placeholder='Weight in Pounds'
                value={props.surveyForm.weight}
                name='weight'
            />
        </>
    )
}

const SexInput = (props) => {
    const type = 'radio'
    const options = ['Male', 'Female']
    return (
        <>
            <Form.Label>Sex</Form.Label>
            <div>
                {options.map((option, idx) =>

                    <Form.Check inline label={option} name={props.name} type={type} onChange={() => props.onChange(props.name, option)} key={`${type}${option}${idx}`} id={`${type}${option}${idx}`} />
                )}


            </div>


        </>
    )
}

const RaceInput = (props) => {
    const type = 'radio'
    const options = ['Asian or Pacific Islander', 'Black or African American', 'Hispanic or Latino', 'Native American or Alaskan Native', 'White or Caucasian', 'Multiracial or Biracial', 'A race/ethnicity not listed here']
    return (
        <>
            <Form.Label>Which of the following best describes you?</Form.Label>
            <div>
                {options.map((option, idx) =>

                    <Form.Check inline label={option} name={props.name} type={type} onChange={() => props.onChange(props.name, option)} key={`${type}${option}${idx}`} id={`${type}${option}${idx}`} />
                )}


            </div>


        </>
    )
}

const MedicalConditionsInfluenceDiet = (props) => {
    return (
        <>
            <Form.Label>Do you have any medical conditions or preferences that influence your diet? Check all that apply.</Form.Label>
            {['checkbox'].map((type) => (
                <div key={`inline-${type}`} className="mb-3 justify-content-center">
                    {['Diabetes', 'High Blood Pressure', 'Celiac Disease', 'Irritable Bowel Syndrome', 'Allergies', 'IBD', 'Cancer'].map((question, idx) =>
                        <Form.Check inline label={question} name={`have comorbids ${question}`} type={type} onChange={props.onChange} key={`comorbidsCheckbox-${type}-${idx}`} id={`comorbidsCheckbox-${type}-${idx}`} />
                    )}
                </div>
            ))}
        </>
    )
}

const FoodRestrictionsValues = (props) => {
    return (
        <>
            <Form.Label>Do you have any food restrictions based on your values?  Check all that apply.</Form.Label>
            {['checkbox'].map((type) => (
                <div key={`inline-${type}`} className="mb-3 justify-content-center">
                    {['Religious Values', 'Vegetarian', 'Vegan'].map((question, idx) =>
                        <Form.Check inline label={question} name={question} type={type} onChange={props.onChange} key={`firstCheckbox-${type}-${idx}`} id={`firstCheckbox-${type}-${idx}`} />
                    )}
                </div>
            ))}
        </>
    )
}

const DietsTriedInPast = (props) => {
    return (
        <>
            <Form.Label>Check all diets you have tried in the past</Form.Label>
            {['checkbox'].map((type) => (
                <div key={`inline-${type}`} className="mb-3 justify-content-center">
                    {['Keto', 'Diabetic', 'Mediterranean', 'DASH', 'FODMAP', 'Intermittent Fasting', 'Weight Watchers'].map((question, idx) =>
                        <Form.Check inline label={question} name={`tried ${question}`} type={type} onChange={props.onChange} key={`secondCheckbox-${type}-${idx}`} id={`secondCheckbox-${type}-${idx}`} />
                    )}
                </div>
            ))}</>
    )
}

const OnDiet = (props) => {
    return (
        <>
            <Form.Label>Are you on a diet? </Form.Label>
            {['checkbox'].map((type) => (
                <div key={`inline-${type}`} className="mb-3 justify-content-center">
                    {['Keto', 'Diabetic', 'Mediterranean', 'DASH', 'FODMAP', 'Intermittent Fasting', 'Weight Watchers'].map((question, idx) =>
                        <Form.Check inline label={question} name={`on ${question}`} type={type} onChange={props.onChange} key={`thirdCheckbox-${type}-${idx}`} id={`thirdCheckbox-${type}-${idx}`} />
                    )}
                </div>
            ))}
        </>
    )
}

const HaveHadBariatricSurgery = (props) => {
    const type = 'radio'
    return (
        <>
            <Form.Label>Have you had bariatric surgery? </Form.Label>
            <div>
                <Form.Check inline label='Yes' name={props.name} type={type} onChange={() => props.onChange(props.name, true)} key={`yes-${type}-yes`} id={`yes-${type}-yes`} />

                <Form.Check inline label='No' name={props.name} type={type} onChange={() => props.onChange(props.name, false)} key={`no-${type}-no`} id={`no-${type}-no`} />
            </div>
        </>
    )
}

const EducationLevel = (props) => {
    const type = 'radio'
    const options = ['Did not graduate high school', 'High school', 'Associates', 'Bachelors', 'Post-Graduate']
    return (
        <>
            <Form.Label>Highest Level of Education </Form.Label>
            <div>
                {options.map((option, idx) =>

                    <Form.Check inline label={option} name={props.name} type={type} onChange={() => props.onChange(props.name, option)} key={`${type}${option}${idx}`} id={`${type}${option}${idx}`} />
                )}


            </div>


        </>
    )
}

const InterestedLearningAbout = (props) => {
    return (
        <>
            <Form.Label>Which diets are you most interested in learning about?</Form.Label>
            {
                ['checkbox'].map((type) => (
                    <div key={`inline-${type}`} className="mb-3 justify-content-center">
                        {['Keto', 'Diabetic', 'Mediterranean', 'DASH', 'FODMAP', 'Intermittent Fasting'].map((question, idx) =>
                            <Form.Check inline label={question} name={`interested in ${question}`} type={type} onChange={props.onChange} key={`sixCheckbox-${type}-${idx}`} id={`sixCheckbox-${type}-${idx}`} />
                        )}
                    </div>
                ))
            }
        </>
    )
}

const HowPreferToLearn = (props) => {
    const type = 'radio'
    const options = ['Videos', 'Written Recipes']
    return (
        <>
            <Form.Label>How do you prefer to learn?</Form.Label>
            <div>
                {options.map((option, idx) =>

                    <Form.Check inline label={option} name={props.name} type={type} onChange={() => props.onChange(props.name, option)} key={`${type}${option}${idx}`} id={`${type}${option}${idx}`} />
                )}


            </div>


        </>
    )
}
